import { render, staticRenderFns } from "./UpdateDonorsState.vue?vue&type=template&id=54facd3f"
import script from "./UpdateDonorsState.vue?vue&type=script&lang=js"
export * from "./UpdateDonorsState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports